import { Component, Input } from '@angular/core'

import { LEASE_STATUS_COLOR_ENUM } from '@modules/private/lease/data/enum/lease.enum'

/**
 * Renglón «Estado del arrendamiento: antes → después» que acompaña la vista previa de una operación sobre
 * los saldos. Una sola copia para el editor de saldos y para «Deshacer» de la Bitácora: los dos corren la
 * misma sincronización de estado en el backend y no pueden decirlo de dos formas.
 *
 * No se pinta si el estado no cambia o si la respuesta no trae el dato (una API anterior).
 */
@Component({
  selector: 'app-lease-status-change',
  templateUrl: './lease-status-change.component.html',
  styleUrls: ['./lease-status-change.component.scss'],
})
export class LeaseStatusChangeComponent {
  @Input() before: string | null | undefined
  @Input() after: string | null | undefined

  get changed(): boolean {
    return !!this.before && !!this.after && this.before !== this.after
  }

  /** El color canónico del estado, el mismo de la lista de arrendamientos. */
  severity(status: string | null | undefined): string {
    return (LEASE_STATUS_COLOR_ENUM as Record<string, string>)[status ?? ''] ?? 'secondary'
  }
}
